import type { CSSProperties } from 'react'
import React from 'react'
import { atTextDirection } from '@fs/zion-ui'
import { Elevation } from '@fs/zion-ui/quarks-authorized-use-only'
import { PlaceTemple } from '@fs/zion-icon'
import { css } from '@emotion/core'

const iconCss = css`
  border-radius: 100%;
  width: 28px;
  height: 28px;
  background: var(--button-background);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  inset-inline-end: 0;
`

type TempleIconProps = {
  color?: string
  background?: string
  style?: CSSProperties
  hasTimer?: boolean
}

export default ({ color, background, style, hasTimer }: TempleIconProps): JSX.Element => (
  <div
    data-testid="temple-icon"
    css={iconCss}
    style={{
      color,
      '--button-background': background,
      ...(style ?? {}),
    }}
  >
    <PlaceTemple size="xs" />
    {hasTimer && <TempleTimerIcon style={{ top: -3, insetInlineEnd: -3, position: 'absolute' }} />}
  </div>
)

type TempleTimerIconProps = {
  style: CSSProperties
}

export function TempleTimerIcon({ style }: TempleTimerIconProps): JSX.Element {
  return (
    <Elevation
      z={6}
      style={{ borderRadius: '100%', width: 14, height: 14, background: 'var(--button-background)', ...style }}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        transform={atTextDirection({ ltr: undefined, rtl: 'scale(-1, 1)' })}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'block' }}
      >
        <path
          transform="translate(0, -1)"
          d="M9 2 h6 v2 H9Z m2 13V9h2v6Zm8-6.63L20.45 7A11 11 0 0 0 19 5.55L17.62 7A9 9 0 1 0 19 8.38ZM5 14a7 7 0 1 0 7-7 7 7 0 0 0-7 7Z"
          fill="currentcolor"
          fillRule="evenodd"
        />
      </svg>
    </Elevation>
  )
}
